// 模拟数据生成器
const generateId = () => Date.now().toString(36) + Math.random().toString(36).slice(2);

// 模拟用户数据
export const mockUsers = [
  {
    id: '1',
    username: 'admin',
    email: 'admin@blog.com',
    password: '123456',
    nickname: '系统管理员',
    role: 'admin',
    avatar: 'https://picsum.photos/100?random=1',
    bio: '我是系统管理员',
    stats: { posts: 10, followers: 100 },
    createdAt: '2024-01-01T00:00:00.000Z',
  },
  {
    id: '2',
    username: 'cute_dev',
    nickname: '可爱开发者',
    email: 'cute.dev@example.com',
    avatar: 'https://picsum.photos/100?random=1',
    bio: '热爱前端开发，喜欢创造可爱有趣的UI，分享技术心得和生活感悟。',
    role: 'admin',
    createdAt: '2023-01-15T08:00:00Z',
    stats: {
      posts: 28,
      followers: 365,
      following: 42,
      likes: 1250,
    },
  },
  {
    id: '3',
    username: 'ui_designer',
    nickname: 'UI设计师小红',
    email: 'ui.designer@example.com',
    avatar: 'https://picsum.photos/100?random=2',
    bio: '专注于可爱风格UI设计，喜欢创造温暖的用户体验。',
    role: 'user',
    createdAt: '2023-03-20T10:30:00Z',
    stats: {
      posts: 12,
      followers: 189,
      following: 56,
      likes: 456,
    },
  },
];

// 模拟标签数据
export const mockTags = [
  { id: '1', name: 'React', color: 'pink', count: 12 },
  { id: '2', name: 'JavaScript', color: 'gold', count: 8 },
  { id: '3', name: 'CSS', color: 'blue', count: 6 },
  { id: '4', name: '前端', color: 'green', count: 15 },
  { id: '5', name: '教程', color: 'purple', count: 7 },
  { id: '6', name: '设计', color: 'cyan', count: 5 },
  { id: '7', name: 'Ant Design', color: 'magenta', count: 9 },
  { id: '8', name: 'TypeScript', color: 'geekblue', count: 4 },
  { id: '9', name: 'Vue', color: 'lime', count: 3 },
  { id: '10', name: 'Node.js', color: 'orange', count: 2 },
];

// 模拟文章数据
let _mockPosts = [
  {
    id: '1',
    title: 'React Hooks 的奇妙冒险：打造可爱博客的秘密武器',
    content: '详细讲解React Hooks的使用技巧和实践经验...',
    summary: '探索React Hooks的强大功能，让函数组件也能拥有状态和生命周期...',
    author: mockUsers[0],
    cover: 'https://picsum.photos/800/400?random=1',
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    tags: ['React', 'Hooks', '前端开发', '可爱风格', '博客'],
    category: 'technology',
    status: 'published',
    views: 1256,
    likes: 142,
    comments: 28,
    isHot: true,
    readTime: 8,
  },
  {
    id: '2',
    title: 'Ant Design 可爱风格改造指南',
    content: '如何将Ant Design打造成清新可爱风格...',
    summary: '如何将Ant Design打造成清新可爱风格，让UI更加温馨友好...',
    author: mockUsers[1],
    cover: 'https://picsum.photos/800/400?random=2',
    createdAt: '2024-01-14T14:30:00Z',
    updatedAt: '2024-01-14T14:30:00Z',
    tags: ['Ant Design', 'UI', '设计', '可爱风格'],
    category: 'design',
    status: 'published',
    views: 203,
    likes: 38,
    comments: 12,
    isHot: true,
    readTime: 5,
  },
  {
    id: '3',
    title: 'CSS动画打造生动交互',
    content: '使用CSS动画为网站添加生动有趣的交互效果...',
    summary: '使用CSS动画为网站添加生动有趣的交互效果，提升用户体验...',
    author: mockUsers[0],
    cover: 'https://picsum.photos/800/400?random=3',
    createdAt: '2024-01-13T09:15:00Z',
    updatedAt: '2024-01-13T09:15:00Z',
    tags: ['CSS', '动画', '前端', '交互设计'],
    category: 'tutorial',
    status: 'published',
    views: 189,
    likes: 56,
    comments: 5,
    isHot: false,
    readTime: 6,
  },
  {
    id: '4',
    title: 'JavaScript ES6+ 新特性解析',
    content: '深入解析JavaScript ES6及之后版本的新特性...',
    summary: '深入解析JavaScript ES6及之后版本的新特性，提升开发效率...',
    author: mockUsers[0],
    cover: 'https://picsum.photos/800/400?random=4',
    createdAt: '2024-01-12T16:45:00Z',
    updatedAt: '2024-01-12T16:45:00Z',
    tags: ['JavaScript', 'ES6', '编程', '新特性'],
    category: 'technology',
    status: 'published',
    views: 178,
    likes: 47,
    comments: 9,
    isHot: false,
    readTime: 7,
  },
  {
    id: '5',
    title: 'TypeScript 类型系统完全指南',
    content: 'TypeScript类型系统的详细讲解和实践应用...',
    summary: 'TypeScript类型系统的详细讲解和实践应用，提升代码质量...',
    author: mockUsers[0],
    cover: 'https://picsum.photos/800/400?random=5',
    createdAt: '2023-12-20T11:20:00Z',
    updatedAt: '2023-12-20T11:20:00Z',
    tags: ['TypeScript', '前端', '编程'],
    category: 'technology',
    status: 'published',
    views: 234,
    likes: 89,
    comments: 15,
    isHot: true,
    readTime: 10,
  },
  {
    id: '6',
    title: 'Vue 3 组合式API实践',
    content: 'Vue 3组合式API的使用方法和最佳实践...',
    summary: 'Vue 3组合式API的使用方法和最佳实践，提升开发体验...',
    author: mockUsers[0],
    cover: 'https://picsum.photos/800/400?random=6',
    createdAt: '2023-12-15T15:30:00Z',
    updatedAt: '2023-12-15T15:30:00Z',
    tags: ['Vue', '前端', '框架'],
    category: 'tutorial',
    status: 'published',
    views: 198,
    likes: 67,
    comments: 8,
    isHot: false,
    readTime: 5,
  },
  {
    id: '7',
    title: 'Webpack 5 配置优化',
    content: 'Webpack 5的配置优化技巧和性能提升...',
    summary: 'Webpack 5的配置优化技巧和性能提升，加快构建速度...',
    author: mockUsers[0],
    cover: 'https://picsum.photos/800/400?random=7',
    createdAt: '2023-12-10T09:45:00Z',
    updatedAt: '2023-12-10T09:45:00Z',
    tags: ['Webpack', '工程化', '前端'],
    category: 'technology',
    status: 'published',
    views: 145,
    likes: 34,
    comments: 4,
    isHot: false,
    readTime: 6,
  },
];

//获取可修改的文章列表
export const getLatestMockPosts = () => {
  return JSON.parse(JSON.stringify(_mockPosts));  // 返回深拷贝
};

// 更新文章的函数
export const updateMockPost = (id, newData) => {
  const index = _mockPosts.findIndex(post => post.id === id);
  if (index === -1) return false;
  
  _mockPosts[index] = {
    ..._mockPosts[index],
    ...newData,
    updatedAt: new Date().toISOString()
  };
  return true;
};

// 导出可修改的mockPosts
export const mockPosts = _mockPosts;

// 模拟评论数据
export const mockComments = [
  {
    id: '1',
    postId: '1',
    author: {
      id: '2',
      username: 'ui_designer',
      nickname: 'UI设计师小红',
      avatar: 'https://picsum.photos/50?random=2',
    },
    content: '这篇文章太有用了！正好在学React Hooks，看完收获很大！',
    createdAt: '2024-01-15T12:30:00Z',
    likes: 12,
    replies: [],
  },
  {
    id: '2',
    postId: '1',
    author: {
      id: '3',
      username: 'frontend_learner',
      nickname: '前端学习者',
      avatar: 'https://picsum.photos/50?random=3',
    },
    content: '好喜欢这个可爱风格！想知道配色方案是怎么设计的？',
    createdAt: '2024-01-15T13:45:00Z',
    likes: 8,
    replies: [
      {
        id: '2-1',
        author: mockUsers[0],
        content: '谢谢喜欢！主要使用了粉色#ff85c0、蓝色#36cfc9、紫色#b37feb的渐变色～',
        createdAt: '2024-01-15T14:20:00Z',
        likes: 5,
      },
    ],
  },
  {
    id: '3',
    postId: '1',
    author: {
      id: '4',
      username: 'coding_newbie',
      nickname: '编程新手',
      avatar: 'https://picsum.photos/50?random=4',
    },
    content: '期待更多React教程！能不能讲讲自定义Hook的最佳实践？',
    createdAt: '2024-01-15T15:10:00Z',
    likes: 15,
    replies: [],
  },
];

// 模拟归档数据
export const mockArchives = [
  { year: '2024', count: 4, posts: mockPosts.slice(0, 4) },
  { year: '2023', count: 3, posts: mockPosts.slice(4, 7) },
  { year: '2022', count: 2, posts: [] },
  { year: '2021', count: 1, posts: [] },
];

// 模拟数据生成函数
export const generateMockData = {
  // 生成随机用户
  generateUser: (index) => ({
    id: generateId(),
    username: `user_${index}`,
    nickname: ['小明', '小红', '小蓝', '小绿', '小黄'][index % 5],
    email: `user${index}@example.com`,
    avatar: `https://picsum.photos/50?random=${index}`,
    bio: '这个人很懒，什么也没有留下～',
    role: 'user',
    createdAt: new Date(Date.now() - index * 86400000).toISOString(),
    stats: {
      posts: Math.floor(Math.random() * 20),
      followers: Math.floor(Math.random() * 100),
      following: Math.floor(Math.random() * 50),
      likes: Math.floor(Math.random() * 500),
    },
  }),

  // 生成随机文章
  generatePost: (index) => {
    const titles = [
      'React最佳实践',
      'Vue 3新特性',
      'CSS Grid布局指南',
      'TypeScript类型体操',
      'Webpack配置优化',
      'Node.js性能调优',
      '数据库设计原则',
      '微服务架构实践',
      'Docker容器化部署',
      'Kubernetes入门指南',
    ];
    
    const tags = ['React', 'Vue', 'CSS', 'JavaScript', 'TypeScript', 'Node.js', '数据库', 'Docker'];
    
    return {
      id: generateId(),
      title: titles[index % titles.length],
      content: `这是第${index + 1}篇文章的内容...`,
      summary: `第${index + 1}篇文章的摘要...`,
      author: mockUsers[Math.floor(Math.random() * mockUsers.length)],
      cover: `https://picsum.photos/800/400?random=${index}`,
      createdAt: new Date(Date.now() - index * 172800000).toISOString(),
      updatedAt: new Date(Date.now() - index * 172800000).toISOString(),
      tags: [...new Set([...Array(3)].map(() => tags[Math.floor(Math.random() * tags.length)]))],
      category: ['technology', 'design', 'tutorial', 'life'][Math.floor(Math.random() * 4)],
      status: ['published', 'draft'][Math.floor(Math.random() * 2)],
      views: Math.floor(Math.random() * 1000),
      likes: Math.floor(Math.random() * 200),
      comments: Math.floor(Math.random() * 50),
      isHot: index < 5,
      readTime: Math.floor(Math.random() * 10) + 3,
    };
  },

  // 生成随机评论
  generateComment: (postId, index) => ({
    id: generateId(),
    postId,
    author: {
      id: generateId(),
      username: `commenter_${index}`,
      nickname: ['评论者A', '评论者B', '评论者C', '评论者D'][index % 4],
      avatar: `https://picsum.photos/50?random=${index + 100}`,
    },
    content: `这是第${index + 1}条评论，内容很有趣！`,
    createdAt: new Date(Date.now() - index * 3600000).toISOString(),
    likes: Math.floor(Math.random() * 20),
    replies: [],
  }),
};

// Auth 组件的模拟用户数据
export const authMockUsers = [
  { 
    id: 1, 
    username: 'admin',
    password: '123456', 
    email: 'admin@blog.com'
    },
  { 
    id: 2, 
    username: 'cute_dev',
    password: '123456', 
    email: 'cute.dev@example.com'
    },
  { 
    id: 3, 
    username: 'ui_designer',
    password: '123456', 
    email: 'ui.designer@example.com'
  },
];

// 验证登录的函数
export const verifyAuthLogin = (usernameOrEmail, password) => {
  console.log('🔍 验证登录:', { usernameOrEmail, password });
  
  // 先在 authMockUsers 中查找匹配的用户
  const authUser = authMockUsers.find(u => 
    (u.username === usernameOrEmail || u.email === usernameOrEmail) && 
    u.password === password
  );
  
  if (!authUser) {
    console.log('❌ 登录验证失败: 用户名/邮箱或密码错误');
    return null;
  }
  
  console.log('✅ 登录验证成功:', authUser);
  
  // 然后在 mockUsers 中查找完整的用户信息
  const fullUser = mockUsers.find(user => 
    user.username === authUser.username || 
    user.email === authUser.email
  );
  
  if (!fullUser) {
    console.log('⚠️ 在 mockUsers 中未找到完整用户信息');
    return null;
  }
  
  console.log('✅ 找到完整用户信息:', fullUser);
  
  return { 
    ...fullUser,
    password: undefined  // 不返回密码
  };
};

// 注册用户的函数
export const registerAuthUser = (userData) => {
  const newUser = {
    id: authMockUsers.length + 1,
    ...userData,
  };
  authMockUsers.push(newUser);
  return newUser;
};

// 文章分类常量
export const CATEGORIES = [
  { value: 'technology', label: '技术文章', color: 'blue' },
  { value: 'design', label: '设计分享', color: 'pink' },
  { value: 'tutorial', label: '教程指南', color: 'green' },
  { value: 'life', label: '生活随笔', color: 'orange' },
  { value: 'other', label: '其他', color: 'purple' }
];

// 文章状态常量
export const POST_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  PRIVATE: 'private'
};

// 获取所有标签
export const getAllTags = () => {
  return [...mockTags];
};

// 获取所有分类
export const getAllCategories = () => {
  return [...CATEGORIES];
};

// 获取当前登录用户
export const getCurrentUser = () => {
  const storedUser = localStorage.getItem('currentUser');
  if (!storedUser) return null;
  
  try {
    const userData = JSON.parse(storedUser);
    if (!userData.isLoggedIn) return null;
    
    return mockUsers.find(user => user.username === userData.username) || mockUsers[0];
  } catch (error) {
    console.error('获取当前用户失败:', error);
    return mockUsers[0];
  }
};

// 创建新文章
export const createPost = (postData) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        console.log('createPost 收到的数据:', postData);
        
        // 检查是否从草稿发布
        if (postData.id && postData.id.startsWith('draft_')) {
          console.log('检测到从草稿发布，原ID:', postData.id);
          
          // 为发布文章生成新的ID
          const newId = Date.now().toString();
          
          const newPost = {
            ...postData,
            id: newId, // 生成新ID
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            publishedAt: new Date().toISOString(),
            status: POST_STATUS.PUBLISHED
          };
          
          // 保存到主文章列表
          mockPosts.unshift(newPost);
          console.log('从草稿创建文章成功，新ID:', newId, '文章:', newPost);
          
          // 也保存到 published_articles
          const published = JSON.parse(localStorage.getItem('published_articles') || '[]');
          published.unshift(newPost);
          localStorage.setItem('published_articles', JSON.stringify(published));
          console.log('已保存到 published_articles，数量:', published.length);
          
          resolve(newPost);
        } else {
          // 正常创建
          const newId = Date.now().toString();
          const newPost = {
            id: newId,
            ...postData,
            author: getCurrentUser(),
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            views: 0,
            likes: 0,
            comments: 0,
            isHot: false,
            readTime: Math.ceil(postData.content.length / 1000),
            status: postData.status || POST_STATUS.DRAFT
          };
          
          mockPosts.unshift(newPost);
          console.log('创建文章成功，ID:', newId, '状态:', newPost.status);
          
          // 如果是已发布的，也保存到 published_articles
          if (newPost.status === POST_STATUS.PUBLISHED) {
            const published = JSON.parse(localStorage.getItem('published_articles') || '[]');
            published.unshift(newPost);
            localStorage.setItem('published_articles', JSON.stringify(published));
          }
          
          resolve(newPost);
        }
      } catch (error) {
        console.error('创建文章失败:', error);
        reject(new Error('创建文章失败: ' + error.message));
      }
    }, 500);
  });
};

// 获取文章详情
export const getPostById = (id) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        console.log('getPostById 查找 ID:', id);
        
        // 1. 先在 mockPosts 中查找
        let post = mockPosts.find(p => p.id.toString() === id.toString());
        
        // 2. 如果没有找到，在 published_articles 中查找
        if (!post) {
          console.log('在 mockPosts 中未找到，尝试在 published_articles 中查找');
          const publishedArticlesStr = localStorage.getItem('published_articles');
          if (publishedArticlesStr) {
            try {
              const publishedArticles = JSON.parse(publishedArticlesStr);
              post = publishedArticles.find(p => p.id.toString() === id.toString());
              if (post) {
                console.log('在 published_articles 中找到文章:', post);
              } else {
                console.log('在 published_articles 中未找到文章');
              }
            } catch (error) {
              console.error('解析 published_articles 失败:', error);
            }
          }
        } else {
          console.log('在 mockPosts 中找到文章:', post);
        }
        
        if (!post) {
          console.log('文章不存在, ID:', id);
          // 返回一个默认对象而不是 reject
          resolve({
            id: id,
            title: '文章不存在',
            content: '<p>抱歉，您访问的文章不存在或已被删除。</p>',
            author: { username: '系统', nickname: '系统', avatar: '' },
            createdAt: new Date().toISOString(),
            likes: 0,
            comments: 0,
            views: 0,
            tags: [],
            cover: '',
            readTime: 1,
            status: 'deleted'
          });
          return;
        }
        
        resolve(post);
      } catch (error) {
        console.error('获取文章失败:', error);
        // 返回默认对象而不是 reject
        resolve({
          id: id,
          title: '文章不存在',
          content: '<p>抱歉，获取文章时发生错误。</p>',
          author: { username: '系统', nickname: '系统', avatar: '' },
          createdAt: new Date().toISOString(),
          likes: 0,
          comments: 0,
          views: 0,
          tags: [],
          cover: '',
          readTime: 1,
          status: 'error'
        });
      }
    }, 300);
  });
};

// 更新文章
export const updatePost = (id, postData) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        const index = mockPosts.findIndex(p => p.id === id);
        if (index === -1) {
          reject(new Error('文章不存在'));
          return;
        }
        
        const updatedPost = {
          ...mockPosts[index],
          ...postData,
          updatedAt: new Date().toISOString(),
          id, // 保持原ID不变
          readTime: Math.ceil(postData.content.length / 1000)
        };
        
        mockPosts[index] = updatedPost;
        console.log('更新文章成功:', updatedPost);
        resolve(updatedPost);
      } catch (error) {
        reject(new Error('更新文章失败'));
      }
    }, 500);
  });
};

// 删除文章
export const deletePost = (id) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        const index = mockPosts.findIndex(p => p.id === id);
        if (index === -1) {
          reject(new Error('文章不存在'));
          return;
        }
        
        const deletedPost = mockPosts[index];
        mockPosts.splice(index, 1);
        console.log('删除文章成功:', deletedPost);
        resolve(deletedPost);
      } catch (error) {
        reject(new Error('删除文章失败'));
      }
    }, 500);
  });
};

// 获取用户所有文章
export const getUserPosts = (userId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const userPosts = mockPosts.filter(post => 
        post.author?.id === userId || post.author?.username === userId
      );
      resolve(userPosts);
    }, 300);
  });
};

// 获取草稿文章
export const getDraftPosts = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const drafts = mockPosts.filter(post => post.status === POST_STATUS.DRAFT);
      resolve(drafts);
    }, 300);
  });
};

// 获取已发布文章
export const getPublishedPosts = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const published = mockPosts.filter(post => post.status === POST_STATUS.PUBLISHED);
      resolve(published);
    }, 300);
  });
};

// 通过用户名查找用户
export const findUserByUsername = (username) => {
  return mockUsers.find(user => user.username === username) || null;
};

// 获取用户信息（包含完整信息）
export const getUserProfile = (username) => {
  const user = findUserByUsername(username);
  if (!user) return null;
  
  // 获取该用户的文章
  const userPosts = mockPosts.filter(post => post.author.username === username);
  
  return {
    id: user.id,
    username: user.username,
    nickname: user.nickname,
    email: user.email,
    avatar: user.avatar,
    bio: user.bio,
    joinDate: new Date(user.createdAt).toLocaleDateString('zh-CN'),
    role: user.role,
    stats: {
      posts: userPosts.length,
      followers: user.stats?.followers || 0,
      following: user.stats?.following || 0,
      likes: user.stats?.likes || 0,
      views: userPosts.reduce((sum, post) => sum + (post.views || 0), 0)
    },
    tags: userPosts.flatMap(post => post.tags || [])
      .filter((tag, index, arr) => arr.indexOf(tag) === index) // 去重
      .slice(0, 6) // 最多显示6个标签
  };
};